import { render, staticRenderFns } from "./Jury.vue?vue&type=template&id=ad233c6e&scoped=true&"
import script from "./Jury.vue?vue&type=script&lang=js&"
export * from "./Jury.vue?vue&type=script&lang=js&"
import style0 from "./Jury.vue?vue&type=style&index=0&id=ad233c6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad233c6e",
  null
  
)

export default component.exports